import type {PartValueModifier} from 'schemaDefinition/types';
import {
  deweyNumberModifier,
  deweySourceModifier,
  grepLevelModifier,
  intellectualLevelModifier,
  literatureTypeModifier,
} from 'schemas/valueModifiers';
import {trimDataValue} from '../../../functions/trimDataValue';

export const interceptWorkSetFieldValue: PartValueModifier = parameters => {
  const {value, part} = parameters;

  if (part) {
    if (part.key === 'literatureType') {
      return literatureTypeModifier(parameters);
    }
    if (part.key === 'deweyNumber') {
      return deweyNumberModifier(parameters);
    }

    if (part.key === 'deweySource') {
      return deweySourceModifier(parameters);
    }

    if (part.key === 'intellectualLevel') {
      return intellectualLevelModifier(parameters);
    }

    // part.type === 'text'?
    if (part.key === 'preferredTitle') {
      return {
        value: trimDataValue(value),
      };
    }

    if (part.key === 'grep') {
      return grepLevelModifier(parameters);
    }
  }

  return {value};
};
